import { render } from "./ClientsManager.vue?vue&type=template&id=109dcddc&scoped=true&lang=pug"
import script from "./ClientsManager.vue?vue&type=script&lang=ts"
export * from "./ClientsManager.vue?vue&type=script&lang=ts"

import "./ClientsManager.vue?vue&type=style&index=0&id=109dcddc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-109dcddc"

export default script